export default __webpack_public_path__ + "static/media/viewEmployee.892efb30.png";